<template>
  <div class="longPic">
    <el-card>
      <el-form :inline="true" label-width="120px" size="small">
        <el-form-item>
          <el-button style="margin-left: 20px" type="primary" @click="add"
            >添加</el-button
          >
        </el-form-item>
      </el-form>
    </el-card>
    <el-card v-loading="loading" style="margin-top: 15px">
      <el-table
        :data="list"
        :header-cell-style="getRowClass"
        border
        ref="multipleTable"
        style="width: 100%; flex: auto"
        tooltip-effect="light"
      >
        <el-table-column
          prop="advertisementUrl"
          label="开屏图"
          width="150px"
          height="300px"
          align="center"
        >
          <template slot-scope="{ row }">
            <viewer :images="photo">
              <img
                :src="row.advertisementUrl"
                :key="row.id"
                style="width: auto; height: 50px"
              />
            </viewer>
          </template>
        </el-table-column>
        <el-table-column
          label="链接"
          prop="linkTo"
          width="300px"
        ></el-table-column>
        <el-table-column
          label="显示几秒"
          prop="showSecond"
          width="150px"
        ></el-table-column>
        <el-table-column label="是否展示" prop="deleteStatus" width="150px">
          <template slot-scope="{ row }">
            <el-button type="success" size="mini" v-if="row.deleteStatus == 1"
              >是</el-button
            >
            <el-button type="danger" size="mini" v-if="row.deleteStatus == 0"
              >否</el-button
            >
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          class-name="small-padding fixed-width"
          label="操作"
          fixed="right"
        >
          <template slot-scope="{ row }">
            <div class="done">
              <el-button
                size="mini"
                style="width: 90px; margin: 0 0 10px 10px"
                type="primary"
                @click="changeList(row)"
                >修改</el-button
              >
              <el-button
                size="mini"
                style="width: 90px; margin: 0 0 10px 10px"
                type="success"
                v-if="row.deleteStatus == 0"
                @click="showOrno(row,1)"
                
                >展示</el-button
              >
              <el-button
                size="mini"
                style="width: 90px; margin: 0 0 10px 10px"
                type="danger"
                v-if="row.deleteStatus == 1"
                @click="showOrno(row,0)"
                >隐藏</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <!-- 删除弹出框 -->
    <a-modal
      :visible="delOpen"
      ok-text="确认"
      cancel-text="取消"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <p>确定要删除吗？</p>
    </a-modal>
    <!-- 修改页面 -->
    <a-drawer
      title="开屏广告详情页"
      :width="1000"
      :visible="changevisible"
      :body-style="{ paddingBottom: '80px' }"
      @close="onClose"
    >
      <Change :Changedata="changeData" />
    </a-drawer>
  </div>
</template>
<script>
import Change from "./change";
import Clipboard from "clipboard";
export default {
  components: {
    Change,
  },
  data() {
    return {
      delOpen: false,
      list: [],
      loading: false,
      changevisible: false,
      changeData: [],
      photo: [],
      deleteId: "",
    };
  },
  methods: {
    showOrno(row,val) {
      this.postAxios("/ad/kaiping/update", {
        id: row.id,
        advertisementUrl: row.advertisementUrl,
        linkTo: row.linkTo,
        showSecond: row.showSecond,
        deleteStatus:val
      }).then((res) => {
        if (res.success) {
          this.$message.success(res.message);
          this.getList()
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (res.success == false && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    //复制文本：
    copy() {
      var that = this;
      var clipboard = new Clipboard(".btns"); //单页面引用
      // 　　　var clipboard = new this.Clipboard(".btn"); //在main.js中引用
      clipboard.on("success", (e) => {
        this.$message.success("复制成功");

        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        this.$message.error("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },
    //不删除：
    handleCancel() {
      this.delOpen = false;
    },
    //确定删除
    handleOk() {
      this.getAxios(`/ad/kaiping/delete?id=${this.deleteId}`).then((res) => {
        if (res.success == true) {
          this.$message.success(res.message);
          this.getList();
          this.delOpen = false;
        }
      });
    },
    deleteList(id) {
      this.deleteId = id;
      this.delOpen = true;
    },
    add() {
      this.$router.push("/openScreenAdd");
    },
    // 修改
    changeList(row) {
      this.changevisible = true;
      this.changeData = row;
    },
    onClose() {
      this.changevisible = false;
    },
    //头部样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f5f7fa;color:#000;width:100%;text-aligin:center;text-align: center;";
      } else {
        return "";
      }
    },
    getList() {
      this.getAxios("/ad/kaiping/list").then((res) => {
        if (res.success == true) {
          this.list = res.content;
          this.list.map((i) => {
            this.photo.push(i.advertisementUrl);
          });
          this.totalCount = res.totalCount;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
<style scoped lang="less">
.longPic {
  width: 95%;
  height: auto;
  margin: 20px auto;
}
a {
  color: #606266;
}
/deep/ .el-table .cell {
  text-align: center;
}
</style>